var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.withPanel)?_c('kt-panel',[_c('kt-panel-body',[_c('div',{staticClass:"kt-datatable",attrs:{"id":_vm.id}})])],1):_c('div',{staticClass:"kt-datatable",attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }